'use client';

import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { LOGOUT_URL } from '@unifyapps/network/auth/const';
import { useGetQueryMeta } from '@unifyapps/network/hooks/useGetQueryMeta';
import { executeFetch } from '@unifyapps/network/utils/fetch';
import { postLogoutAndRedirect } from '@unifyapps/network/utils/fetch/utils/logout';
import { addTenantPrefix } from '@unifyapps/network/utils/tenantBasePath';
import { useMqttSubscription } from '../../mqtt';
import { safeJsonParse } from '../../utils/json';

const getUserSessionTopic = (userId: string) => `/user_session/${userId}`;

/**
 * Component that subscribes to user session MQTT topic and handles logout messages.
 * Should be conditionally rendered only when userId is present.
 */
export function UserSessionMqttSubscriber({ userId }: { userId: string }) {
  const queryMeta = useGetQueryMeta();
  const basePath = queryMeta?.basePath;

  const onMessage = useEventCallback((payload: string | Buffer) => {
    const message = safeJsonParse(payload.toString());
    console.debug('[MQTT] User session message received:', message);
    if (
      message &&
      message.activityType === 'LOGOUT' &&
      message.userId?.toString() === userId?.toString()
    ) {
      const logoutUrl = addTenantPrefix(LOGOUT_URL, basePath);
      void postLogoutAndRedirect({ logoutUrl, fallbackUrl: window.location.href, options: queryMeta ? { meta: queryMeta } : undefined, executeFetch });
    }
  });

  // Always call hook unconditionally - topic is guaranteed to be defined since userId is required
  useMqttSubscription(getUserSessionTopic(userId), { onMessage });

  return null;
}
